module.exports = __webpack_public_path__ + "img/1-2-3-4.d878360c.png";